import { render, staticRenderFns } from "./QuoteDraft.vue?vue&type=template&id=2d517208"
import script from "./QuoteDraft.vue?vue&type=script&lang=js"
export * from "./QuoteDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports